import { render } from "./users.vue?vue&type=template&id=d7d4ca66"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"
script.render = render

export default script